import React from 'react';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import ServiceProviderApiClient from "../../../Maintenance/ApiClients/ServiceProviderApiClient";
import { ClientReportCategories } from "../ClientReportCategories";
import CashTransactionsExtractReportCriteria from "./CashTransactionsExtractReportCriteria";
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';

@NeoReport("CashTransactionsExtract", { category: ClientReportCategories.HistoricDataReportExtracts })
export default class CashTransactionsExtractReport extends Report<CashTransactionsExtractReportCriteria> {
    public serviceProviderApiClient = new ServiceProviderApiClient();

    constructor() {
        super(CashTransactionsExtractReportCriteria);
    }

    public renderCriteria() {
        return <>
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingID}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                    />
                </Neo.FormGroup>
                <Neo.FormGroup
                    appendText="fa-calendar"
                    bind={this.criteria.meta.date} 
                />
            </Neo.GridLayout>
        </>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}